import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";
import LoadingScreen from "../components/layout/Loading/Loading";
export default function RotaPrivada({children, perfisPermitidos}){
    const {usuario, carregando} = useAuth()
    
   if(carregando){
    return(
        <LoadingScreen/>
    )
   }
    if(!usuario){
        return <Navigate to={"/login"} replace/>
    }
    if(perfisPermitidos && !perfisPermitidos.includes(usuario.perfil)){
         return <Navigate to={"/"} replace/>
    }
    return children;
}